{
	"title": "nakazawa 🐇🥕🐰",
	"description": "🐇🥕🐰",
	"buttons": {
		"fullscreen": "Tela Cheia",
		"achievements": "Conquistas",
		"reset": "Reiniciar",
		"language": "Idioma"
	},
	"achievements": {
		"title": "Conquistas",
		"noAchievements": "Nenhuma conquista ainda. Continue clicando!",
		"unlocked": "Conquista Desbloqueada: {{message}}",
		"progress": "{{progress}}%",
		"beginner": "🎯 Coelho Iniciante",
		"carrotSnatcher": "🥕 Ladrão de Vegetais",
		"bunnyBerserker": "😡 Coelho Furioso",
		"hopPunk": "🎸 Coelho Anarquista",
		"bunnyNinja": "🥷 Silencioso mas Mortal",
		"expert": "🌟 Saltador Especialista",
		"master": "👑 Rei da Cenoura",
		"carrotpocalypse": "🥕 Destruidor de Hortas",
		"bunnyOverlord": "😈 Líder Supremo da Toca",
		"chaosHare": "🌪️ Agente do Caos",
		"carrotCultist": "⛪ Sumo Sacerdote do Culto da Cenoura",
		"bunnyberryPie": "🥧 Mestre da Torta Alucinógena",
		"rabbitHole": "🕳️ Escavador de Túneis Quânticos",
		"moonRabbit": "🌙 Coelho Lunar",
		"bunnyDoom": "💀 Arauto do Coelhocalipse",
		"carrotNuke": "☢️ Portador da Cenoura Nuclear",
		"bunnyMatrix": "🤖 Falha na Matriz dos Coelhos",
		"cosmicHare": "🌌 A Lebre Cósmica Desperta",
		"warrenSingularity": "🕳️ Singularidade da Toca Alcançada",
		"eternalBunny": "♾️ O Coelho Eterno"
	},
	"messages": {
		"prophecy": "A antiga profecia dos cliques começa a se revelar...",
		"cosmic": "Os clicadores cósmicos ficariam orgulhosos do seu progresso!",
		"astral": "Os cliques ecoam pelo plano astral...",
		"speaking": "Espera... você ouviu isso? Os cliques estão falando comigo...",
		"ancient": "Seus cliques ressoam com poder ancestral!",
		"sages": "Os Sábios do Clique sussurram sobre seu potencial...",
		"demons": "CONTEMPLEM! Os Demônios do Clique despertam de seu sono!",
		"veil": "Seus cliques atravessam o véu da realidade!",
		"spirits": "Os Espíritos do Clique dançam ao seu ritmo...",
		"council": "O Grande Conselho do Clique notou sua dedicação",
		"primordial": "Seus cliques despertam forças primordiais!",
		"void": "O vazio dos cliques olha de volta para você...",
		"runes": "Antigas runas de clique brilham com seu poder!",
		"beast": "TRÊS TRÊS TRÊS - O NÚMERO DA BESTA DO CLIQUE",
		"prophets": "Os Profetas do Clique cantam sobre sua vinda!",
		"dimensions": "Seus cliques ecoam através das dimensões...",
		"portal": "Seus cliques abriram um portal para a Dimensão do Clique!",
		"sacrifice": "Os antigos Deuses do Clique exigem MAIS SACRIFÍCIO",
		"jackpot": "JACKPOT! O Cassino do Clique recebe seu mais novo campeão!",
		"unmatched": "Seu poder de clique é incomparável!",
		"reality": "A própria realidade se curva à sua vontade de clicar!",
		"elite": "VOCÊ SE TORNOU O MESTRE ELITE DO CLIQUE",
		"power": "Seu nível de poder de clique está acima de 1500!",
		"devils": "Os Demônios do Clique se curvam diante de seu poder",
		"lucky": "Cliques sortudos fluem por suas veias",
		"dynasty": "A Dinastia do Clique reconhece sua supremacia",
		"twoThousand": "Dois mil cliques de puro poder!",
		"quartet": "A profecia do Quarteto do Clique foi cumprida",
		"transcend": "Seus cliques transcendem o entendimento mortal",
		"constellation": "A Constelação do Clique se alinha em sua honra",
		"destiny": "TRÊS MIL CLIQUES DO DESTINO",
		"triforce": "A Triforce Tripla do Clique desperta!",
		"fortune": "A fortuna favorece o clicador persistente",
		"newDimensions": "Seu poder de clique alcança novas dimensões",
		"quartet2": "O Quarteto Quádruplo do Clique harmoniza",
		"threshold": "De pé no limiar da divindade do clique",
		"ultimate": "CINCO MIL CLIQUES DE PODER SUPREMO!",
		"force": "A Força dos Cinco Dedos do Clique está sob seu comando",
		"underworld": "O Submundo do Clique o coroa como seu governante",
		"maxJackpot": "JACKPOT MÁXIMO DE CLIQUES ALCANÇADO",
		"infinite": "PODER DE CLIQUE INFINITO!",
		"godhood": "VOCÊ ASCENDEU À DIVINDADE DO CLIQUE",
		"burrow": "Você cavou mais fundo do que qualquer coelho antes...",
		"warren": "A Grande Toca reconhece sua presença...",
		"thump": "A terra treme a cada batida do seu pé!",
		"darkWarren": "A Toca Sombria abre seus portões para você...",
		"ears": "Suas orelhas ficam mais longas... agora você pode ouvir tudo...",
		"carrotThrone": "O Trono de Cenoura se materializa diante de você...",
		"onesAlignment": "Todos os uns se alinham - a Frequência da Toca ressoa!",
		"moonSummon": "O Coelho Lunar ouve seu chamado através do vazio...",
		"edgeOfForever": "Você está à beira da eternidade... orelhas tremendo...",
		"beyondTheVeil": "Além do véu, todas as tocas se tornam uma...",
		"sequence": "1-2-3-4-5... A Sequência Sagrada do Salto está completa!",
		"hyperElite": "STATUS HIPER ELITE DESBLOQUEADO 🐇🐇🐇",
		"eventHorizon": "Além do horizonte de eventos da Toca Cósmica...",
		"matrixAwakens": "A Matrix da Toca falha... você vê as cenouras por trás da realidade",
		"luckyForever": "Cada pata, cada salto, cada tremor... abençoado para sempre",
		"twentyK": "VINTE MIL. Você não é mais um coelho. Você é O coelho.",
		"singularity": "A Singularidade Coelhesca. Todos os coelhos são você. Você é todos os coelhos.",
		"tripleAscension": "A Tripla Ascensão da Lebre Cósmica!",
		"ultimateAnswer": "42.000 - A Resposta Definitiva sempre foram cenouras",
		"eternity": "♾️ A TOCA ETERNA NÃO TEM FIM. NEM VOCÊ. ♾️"
	},
	"powerups": {
		"bonusPoints": "🥕 +{{count}} Pontos Bônus!",
		"clickStreak": "🔥 {{count}} Cliques Seguidos!",
		"fire": "🔥 Poder de Fogo Ativado!"
	},
	"table": {
		"achievement": "Conquista",
		"progress": "Progresso"
	},
	"reset": {
		"confirm": "Tem certeza que deseja reiniciar todo o progresso? Isso não pode ser desfeito."
	}
}
